import { audiences } from "./audiences";
import { channels } from "./channels";
import { knowledge } from "./knowledge";
import { metaCallback } from "./meta-callback";
import { sourceDetail } from "./source-detail";
import { widgetStudio } from "./widget-studio";

/** Deploy + knowledge console screens (P6 group `deploy-knowledge`). One file per screen. */
export const deployKnowledge = {
  planGate: {
    title: "{{feature}} needs a higher plan",
    badge: "Plan feature",
    body: "Your current plan doesn't include this. Upgrade to unlock it — your settings are kept.",
    upgrade: "Compare plans",
  },
  storageFull: {
    title: "Your knowledge storage is full",
    body: "New files, pages and text can't be added until you delete sources, add storage or upgrade. Everything you already added keeps answering.",
    add: "Add storage",
  },
  loadError: "This page couldn't load.",
  loadErrorBody: "Check your connection and try again. Nothing was lost.",
  noPermission: "You don't have permission to change this",
  readOnly: "Read-only during a support session",
  unsavedChanges: "Unsaved changes",
  saving: "Saving…",
  knowledge,
  sourceDetail,
  widgetStudio,
  channels,
  audiences,
  metaCallback,
} as const;
